import { render } from "./modPresResColGen.vue?vue&type=template&id=184b1e95&scoped=true"
import script from "./modPresResColGen.vue?vue&type=script&lang=js"
export * from "./modPresResColGen.vue?vue&type=script&lang=js"

import "./modPresResColGen.vue?vue&type=style&index=0&id=184b1e95&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-184b1e95"

export default script